import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { IGroup } from './group.model';
import { RestService } from '../../service/api/rest.service';

@Injectable({providedIn: 'root'})
export class GroupsEntityService extends EntityCollectionServiceBase<IGroup>
{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private rest: RestService)
    {
        super('Group', serviceElementsFactory);
    }
}
